import {deleteCookie} from "@js/globalFunctions/cookieHandling";

export function resetStoredData(){
	$(document).find("textarea#contentHolderPaging").val("");
	$(document).find("textarea#contentHolderTextarea").val("");
	deleteCookie('tempContentHolderArea');
	deleteCookie('tempContentHolderPaging');
}
